import { formatTime } from "../utils/video-duration.js";

export function initVideoDuration({
  container = '.video-category-detail',
  videoSelector = 'video',
  durationSelector = '.duration',
} = {}) {

  const root =
    typeof container === 'string'
      ? document.querySelectorAll(container)
      : [container];

  if (!root.length) return;

  root.forEach(el => {
    const video = el.querySelector(videoSelector);
    const durationEl = el.querySelector(durationSelector);

    if (!video || !durationEl) return;

    const update = () => {
      if (isNaN(video.duration)) return;

      durationEl.innerText = formatTime(video.duration);
    };

    if (video.readyState >= 1) {
      update();
    } else {
      video.addEventListener('loadedmetadata', update, { once: true });
    }
  });
}